import { GET_PROVINCES } from "@jumbo/constants/ActionTypes";


const INIT_STATE = {
    dataProvinces: [],
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_PROVINCES:
            return {
                ...state,
                dataProvinces: action.payload
            }
        default:
            return state
    }
}